module.exports = __webpack_public_path__ + "static/media/United Kingdom.f503da6f.png";